// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchItem_wrapper__v8W75","link":"SearchItem_link__XFxJQ","badge":"SearchItem_badge__nclVt","post":"SearchItem_post__crP_1","get":"SearchItem_get__luwL1"};